(async () => {
    var t = await import(window.theme.modules.baseComponent);
    customElements.define(
        "main-nav",
        class extends t.default {
            elements = { 
              dropdowns: "*[data-dropdown]",
              wrappers : "*[data-dropdown-wrapper]"
            };
            modalInit = !1;
            render() {
                this.$dropdowns
                    .filter((t) => t.hasAttribute("data-offset-drop"))
                    .map((t) => {
                        var e = t.getBoundingClientRect();
                        document.documentElement.clientWidth - e.x + e.width < 600 && t.classList.add("@drop-reverse");
                    });
                this.$dropdowns.map(this._handleDropdown.bind(this))
            }
            reRender() {
                this.closest("modal-popup") &&
                    !this.modalInit &&
                    ((this.modalInit = !0),
                    this.$dropdowns.map((t) => {
                        t.addEventListener("click", (t) => {
                            t.preventDefault();
                            t = t.currentTarget.dataset.dropdown;
                            const e = this.querySelector(`[data-dropby="${t}"]`);
                            e.classList.toggle("!active");
                        });
                    }));
            }
            _handleDropdown(drop) {
            // $hover(drop, (e, state) => this.publish('lights-out', state));
           //   debugger;
          var menuItems = this.$wrappers;
          var _this = this;
 
              var hoverIntent = new SV.HoverIntent(menuItems, {
                // required parameters
                onEnter: function(targetItem) {
                    t = targetItem.querySelector("*[data-dropdown]").dataset.dropdown;
                    const e = targetItem.querySelector(`[data-dropby="${t}"]`);
                    e.classList.add("!active");
                },
                onExit: function(targetItem) {
                   t = targetItem.querySelector("*[data-dropdown]").dataset.dropdown;
                    const e = targetItem.querySelector(`[data-dropby="${t}"]`);
                    e.classList.remove("!active");
                },
              
                // default options
                exitDelay: 300,
                interval: 100,
                sensitivity: 6,
              });
          
        }
        }
    );
})();